module.exports = __webpack_public_path__ + "static/assets/870d942b2502550f58b9eab7561f42ec.svg";